import { useEffect, useState, ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
  children: ReactNode;
}

const Portal = ({ children }: PortalProps) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (typeof window === 'undefined' || !mounted) {
    return null;
  }

  const portalRoot = document.getElementById('portal-root');
  if (!portalRoot) {
    // In a real app, you might want to create this element if it doesn't exist
    // or have a more robust fallback.
    console.error('The element with id "portal-root" was not found in the DOM.');
    return null;
  }

  return createPortal(children, portalRoot);
};

export default Portal;
